module.exports = __webpack_public_path__ + "img/xroad_logo_64.b1753487.png";